import { Component, Input, OnDestroy } from '@angular/core';
import { BaseComponent } from '@ridango/core';
import { UiAction } from '../../../../services/ticket-actions/ticket-actions.service';

@Component({
    selector: 'rwidget-ticket-contextual-menu',
    templateUrl: './ticket-contextual-menu.component.html',
    styleUrls: ['ticket-contextual-menu.component.scss']
})
export class TicketContextualMenuComponent extends BaseComponent implements OnDestroy {
    @Input() actions: UiAction[] = [];
    @Input() mode: 'default' | 'dialog' = 'default';

    constructor() {
        super();
    }

    invokeHandler(action: UiAction): void {
        if (action.handler) {
            action.handler();
        }
    }

    ngOnDestroy() {
        super.ngOnDestroy();
    }
}
